
import { Component, Vue } from 'nuxt-property-decorator'
import { Prop } from 'vue-property-decorator'
import Error from '~/components/Error.vue'

@Component({
  components: { Error },
})
export default class extends Vue {
  @Prop({ type: Object }) error: Error
}
